import { useDispatch, useSelector } from "react-redux";
import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Spinner,
} from "reactstrap";
import { deleteSupportAction } from "store/actions/supportActions";
import { emitAdminDelete } from "config/socketConfig";

const DeleteTeamModal = ({ id, modal, toggle }) => {
  console.log("id: ", id);
  const { deleteSupportLoader } = useSelector((state) => state.support);
  const dispatch = useDispatch();
  return (
    <div>
      <Modal isOpen={modal} toggle={toggle} centered>
        <ModalHeader toggle={toggle}>Delete Team</ModalHeader>
        <ModalBody>Are you sure you want to delete ?</ModalBody>
        <ModalFooter>
          <Button
            color="danger"
            disabled={deleteSupportLoader}
            onClick={() => {
              dispatch(
                deleteSupportAction(id, () => {
                  emitAdminDelete({ userId: id, id: id, action: "delete" });
                  toggle();
                })
              );
            }}
          >
            {deleteSupportLoader ? <Spinner size="sm" /> : "Delete"}
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default DeleteTeamModal;
